import { render, staticRenderFns } from "./C-2-1-3__SubCategoryInfo_Tab-Messaging&Highlight.vue?vue&type=template&id=2f9b38c9&"
import script from "./C-2-1-3__SubCategoryInfo_Tab-Messaging&Highlight.vue?vue&type=script&lang=js&"
export * from "./C-2-1-3__SubCategoryInfo_Tab-Messaging&Highlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports